export default __webpack_public_path__ + "static/media/lah-logo.437b5149.svg";